require('./style.less');


var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.stampNoteUiModel = options.stampNoteUiModel;

    },

    ui: {
        'useExistingCb': '.existing-wc-checkbox'
    },

    events: {

        'change @ui.useExistingCb': 'onUseExistingTokensChange'
    },

    serializeData: function() {

        var originalTokens = this.stampNoteUiModel.get( 'originalStampTokens' );

        var messageForExistingTokens = 'Selected stamp was originally created with the following token values: ' +
            originalTokens.map( function( t ) {
                return t.get('key') + ' (' + t.get('value') + ')';
            } ).join(', ') + '.';

        return {
            message: messageForExistingTokens,
            useNewValues: this.stampNoteUiModel.get( 'useNewTokenValues' )
        };

    },

    onUseExistingTokensChange: function() {

        this.stampNoteUiModel.toggleUseNewTokenValues();

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/textStamp/existingTokens/view.js
 ** module id = 331
 ** module chunks = 0
 **/